import { render } from "./VehicleSelect.vue?vue&type=template&id=2807a852"
import script from "./VehicleSelect.vue?vue&type=script&lang=js"
export * from "./VehicleSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__